var _metadata, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompletedGigs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "18pt",
    height: "18pt",
    viewBox: "0 0 101.000000 101.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "\nCreated by potrace 1.16, written by Peter Selinger 2001-2019\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,101.000000) scale(0.100000,-0.100000)",
    fill: "#595757",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355 905 c-21 -20 -25 -34 -25 -85 l0 -60 -104 0 c-154 0 -146 17 -146 -319 1 -193 4 -270 13 -282 27 -35 53 -39 281 -39 l226 0 0 -35 c0 -42 11 -44 93 -16 56 20 58 20 114 0 85 -29 83 -31 83 64 0 63 5 92 20 122 18 36 20 59 20 248 0 207 0 208 -25 232 -22 23 -31 25 -125 25 l-100 0 0 60 c0 51 -4 65 -25 85 -23 24 -30 25 -150 25 -120 0 -127 -1 -150 -25z m475 -312 l0 -68 -83 0 c-89 0 -112 -10 -160 -71 -32 -41 -37 -151 -8 -199 l20 -35 -209 0 -210 0 0 220 0 220 325 0 325 0 0 -67z m-10 -155 c54 -43 63 -126 18 -174 -11 -12 -39 -27 -62 -34 -38 -10 -48 -9 -83 9 -40 20 -73 69 -73 108 0 33 36 86 71 105 42 23 88 18 129 -14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725 410 c-6 -26 -11 -30 -41 -30 -40 0 -43 -11 -9 -38 22 -18 24 -23 14 -51 -15 -42 -5 -49 29 -24 27 20 28 20 51 2 41 -33 49 -19 26 43 -4 9 5 20 20 28 37 20 32 40 -10 40 -31 0 -36 3 -41 30 -4 17 -12 30 -19 30 -8 0 -16 -13 -20 -30z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedGigs);
export default __webpack_public_path__ + "static/media/CompletedGigs.3a87c63e.svg";
export { ForwardRef as ReactComponent };